/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BaseTeamRole {
  MANAGER = 'manager',
  EDITOR = 'editor',
  VIEWER = 'viewer',
}
